import axiosSecurity from '../axios/axiosSecurity'

export default class ColaboradorService {
  static async get(nome = null, ativo = null, departamentoId = null, atuacaoId = null) {
    const params = new URLSearchParams()

    if (nome) params.append('Nome', nome)
    if (ativo !== null) params.append('Ativo', ativo)
    if (departamentoId) params.append('DepartamentoId', departamentoId)
    if (atuacaoId) params.append('AtuacaoId', atuacaoId)

    return axiosSecurity.get(`colaboradores?${params.toString()}`).then(res => res.data.data)
  }

  static async getById(colaboradorId) {
    return axiosSecurity.get(`colaboradores/${colaboradorId}`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosSecurity.post('colaboradores', body)
  }

  static async update(colaboradorId, body) {
    return axiosSecurity.put(`colaboradores/${colaboradorId}`, body)
  }

  static async ativarOuInativar(colaboradorId, body) {
    return axiosSecurity.put(`colaboradores/${colaboradorId}/ativado`, body)
  }

  static async getDepartamentosAssociados(colaboradorId) {
    return axiosSecurity.get(`colaboradores/${colaboradorId}/departamentos`).then(res => res.data.data.items)
  }

  static async desbloquear(colaboradorId) {
    return axiosSecurity.put(`colaboradores/${colaboradorId}/desbloquear`).then(res => res.data.data)
  }

  static async bloquear(colaboradorId) {
    return axiosSecurity.put(`colaboradores/${colaboradorId}/bloquear`).then(res => res.data.data)
  }
}
